import { defineMessages } from 'react-intl'

import { SEASON_TYPE } from './constants'

export const seasonTypeMessages = defineMessages({
  [SEASON_TYPE.L]: {
    id: 'seasonType.low',
    defaultMessage: 'Low season'
  },
  [SEASON_TYPE.H]: {
    id: 'seasonType.high',
    defaultMessage: 'High season'
  },
  [SEASON_TYPE.S]: {
    id: 'seasonType.special',
    defaultMessage: 'Special event'
  },
  [SEASON_TYPE.E]: {
    id: 'seasonType.exception',
    defaultMessage: 'Exception event'
  },
  [SEASON_TYPE.N]: {
    id: 'seasonType.NA',
    defaultMessage: 'N/A'
  }
})
